import { getFromIDB } from "metabase/jerry/Common/indexed-db";

export async function getCardCategory(
  cardId: number | string,
): Promise<string | undefined> {
  try {
    const key = `question:${cardId}`;
    const metadata = await getFromIDB<{ categories?: string[] }>(key);
    if (metadata?.categories?.length) {
      return metadata.categories.join(",");
    }
  } catch (e) {
    // ignore
  }
  return undefined;
}

export async function getDashboardCategory(
  dashboardId: number | string,
): Promise<string | undefined> {
  try {
    const key = `dashboard:${dashboardId}`;
    const metadata = await getFromIDB<{ categories?: string[] }>(key);
    if (metadata?.categories?.length) {
      return metadata.categories.join(",");
    }
  } catch (e) {
    // ignore
  }
  return undefined;
}
